module.exports = __webpack_public_path__ + "img/new.34561e7a.gif";